import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { __ } from '@bart.sk-eshop/react-i18n/lib';
import { formatStringDate } from '../../../utilities';
import { Link } from 'react-router';
import { ButtonStyledStyles, ButtonStyles } from '../../_helpers/form/Button';

const Wrapper = styled.div`
  display: block;
`;

const PaginationWrapper = styled.div`
  display: block;
  margin-top: ${rem(24)};
  &:after {
    display: block;
    clear: both;
    content: '';
  }
`;

const ListWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem(30)};
  ${({ theme }) => theme.media(425)} {
    grid-template-columns: repeat(2, 1fr);
  }
  ${({ theme }) => theme.media('lg')} {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const Article = styled.article`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: ${rem(19)};
  border: ${rem(1)} solid ${({ theme }) => theme.color.gray93};
  background-color: ${({ theme }) => theme.color.white};
  color: #383838;
  font-weight: 500;
  word-wrap: break-word;
`;

const ImageContainer = styled.div`
  position: relative;
  margin: ${rem(-20)} ${rem(-20)} ${rem(29)};
`;

const Anchor = styled(Link)`
  display: block;
  position: relative;
  &:hover {
    text-decoration: none;
  }
`;

const Title = styled.h2`
  font-size: ${rem(18)};
  font-weight: 500;
  color: #211e1f;
`;

const Image = styled.img`
  min-width: 100%;
  max-width: 100%;
  height: auto;
  vertical-align: bottom;
`;

const Meta = styled.p``;

const MetaPublished = styled.span`
  color: #383838;
  font-size: ${rem(14)};
`;

const Content = styled.div`
  color: #383838;
`;

const EmptyMessage = styled.p`
  color: #383838;
`;

const PaginationLeft = styled.div`
  float: left;
`;

const PaginationRight = styled.div`
  float: right;
`;

const PaginationAchor = styled(Anchor)`
  ${ButtonStyles};
  ${ButtonStyledStyles};
  font-size: ${rem(16)};
  &:hover {
    text-decoration: none;
    cursor: pointer;
  }
`;

interface PropsItem {
  article: any;
}

interface PropsList {
  articles: any;
  paginationNextLink: string | null;
  paginationPreviousLink: string | null;
  onClick: () => void;
  onLoaded: () => void;
}

class ArticleListItem extends React.PureComponent<PropsItem> {
  public render() {
    this.props.article.date = formatStringDate(this.props.article.custom_date);
    return (
      <Article id={this.props.article.id}>
        <ImageContainer>
          <Anchor to={this.props.article.url}>
            <Image src={this.props.article.image} />
          </Anchor>
        </ImageContainer>
        <Anchor to={this.props.article.url}>
          <Title>{this.props.article.name}</Title>
        </Anchor>
        <Meta>
          <MetaPublished>{this.props.article.date}</MetaPublished>
        </Meta>
        <Content
          dangerouslySetInnerHTML={{
            __html: this.props?.article?.json_content?.anotation,
          }}
        />
      </Article>
    );
  }
}

class ArticleList extends React.PureComponent<PropsList> {
  public render() {
    this.props.onLoaded();

    return (
      <Wrapper>
        {this.props.articles.length ? (
          <ListWrapper>
            {this.props.articles.map((item) => (
              <ArticleListItem key={item.id} article={item} />
            ))}
          </ListWrapper>
        ) : (
          <EmptyMessage>
            {__('Momentálne tu nie sú žiadne články.')}
          </EmptyMessage>
        )}
        <PaginationWrapper>
          {this.props.paginationNextLink ? (
            <PaginationLeft>
              <PaginationAchor
                to={this.props.paginationNextLink}
                className="primary"
                onClick={this.props.onClick.bind(null)}
              >
                « Staršie záznamy
              </PaginationAchor>
            </PaginationLeft>
          ) : (
            ''
          )}
          {this.props.paginationPreviousLink ? (
            <PaginationRight>
              <PaginationAchor
                to={this.props.paginationPreviousLink}
                className="primary"
                onClick={this.props.onClick.bind(null)}
              >
                Ďalšie položky »
              </PaginationAchor>
            </PaginationRight>
          ) : (
            ''
          )}
        </PaginationWrapper>
      </Wrapper>
    );
  }
}

export default ArticleList;
